import { render } from "./Home.vue?vue&type=template&id=580931fd"
const script = {}

import exportComponent from "/deploy/src/necs_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__